// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4x4Cp","label":"styles_label__1dMsc"};